export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M7 17h10v-2H7zm14 4v-2H3v2zm0-8v-2H3v2zM7 9h10V7H7zM3 5h18V3H3z\"/>"
};